import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export function initI18n(locale: string, translations: Record<string, string>) {
    i18n.use(initReactI18next).init({
        lng: locale,
        resources: {
            [locale]: { translation: translations }
        },
        interpolation: { escapeValue: false }
    });
    return i18n;
}
